export default "__VITE_ASSET__BGRn3N7f__"